export default __webpack_public_path__ + "static/media/email-analytics.32df22f6.png";